import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgBounce = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" {...props}>
    <g
      fill="none"
      fillRule="evenodd"
      stroke="#979797"
      transform="translate(1 1)"
    >
      <circle cx={23} cy={23} r={23} />
      <path d="m7 6 33 33" />
    </g>
  </svg>
);
const Memo = memo(SvgBounce);
export default Memo;
